import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {PreferenceService} from '@service/crm/preference.service';
import {MatDialog} from '@angular/material/dialog';
import {shareReplay, takeUntil, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {QuillEditorComponent} from "ngx-quill";


@Component({
    selector: 'app-message-template',
    templateUrl: './message-template.component.html',
    styleUrls: ['./message-template.component.scss'],
    standalone: false
})
export class MessageTemplateComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('editor') quillEditorComponent!: QuillEditorComponent;
  @Input() mTmplId!: number;
  private destroy$: Subject<void> = new Subject();
  public editorConfig: any;
  data$!: Observable<any>;
  loaded = false;
  modified = false;
  editMode = true;

  public editable = true;

  messageTemplateDataForm;

  constructor(
    private fb: UntypedFormBuilder,
    private preferenceService: PreferenceService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) {
    this.messageTemplateDataForm = this.fb.group({
      label: ['', Validators.required],
      bodyHtml: ['', Validators.required],
      shared: ['']
    });
    this.editorConfig = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        ['link', 'image'],
        [{size: ['small', false, 'large', 'huge']}],
        [{color: []}, {background: []}],
        ['link'],
        ['clean']
      ]
    };
  }

  ngOnInit(): void {
    if (this.editMode) {
      this.data$ = this.preferenceService.getMessageTemplateDetail(this.mTmplId).pipe(
        shareReplay(1)
      );
    }
    this.loaded = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    if (this.editMode) {
      this.data$.pipe(
        takeUntil(this.destroy$),
        tap((data) => data),
      ).subscribe((res) => {
        this.editable = res.editable;
        this.messageTemplateDataForm.patchValue(res);
        if (!res.editable && this.editMode) {
          Object.keys(this.messageTemplateDataForm.controls).forEach(key => {
            this.messageTemplateDataForm.get(key)?.disable();
          });
        }
        setTimeout(() => {
          if (this.quillEditorComponent?.quillEditor) {
            const quill = this.quillEditorComponent.quillEditor;
            const delta = quill.clipboard.convert({html: res.bodyHtml});
            quill.setContents(delta);
          }
        }, 500);
      });
    }
  }

  private _(key: string): string {
    return this.translateService.instant(key);
  }

  confirm(): void {
    const data = this.messageTemplateDataForm.getRawValue();
    const vals = this.editMode ? { ...data, messageTemplateId: this.mTmplId } : data;
    const action$ = this.editMode
      ? this.preferenceService.updateMessageTemplate(vals)
      : this.preferenceService.createMessageTemplate(vals);

    action$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (!res.error) {
        this.snackBar.open(this._('ChangesApplied'), this._('CLOSE'), { duration: 3000 });
        this.modified = true;
        this.closeDialog();
      }
    });
  }



  closeDialog(): void {
    this.dialog.getDialogById('messageTemplate')?.close({modified: this.modified});
  }
}
